<script>
export default {
  name: "UrunListFragment",

  props: {
    value: {
      required: true,
      type: Array
    }
  },

  computed: {
    products() {
      return this.value;
    }
  },

  methods: {
    getProductFeatures(productAttrs, attrs) {
      const attrsArr = [];

      attrs.forEach(attr => {
        const find = productAttrs.find(o => o.code === Number(attr));
        if (find) {
          attrsArr.push(find);
        }
      });

      return attrsArr;
    }
  }
};
</script>

<template>
  <v-row no-gutters class="mb-2">
    <v-col :key="key" v-for="(product, key) in products">
      <v-row>
        <v-col cols="2">
          <v-img :src="product.variations[0].images[0]" class="rounded-lg" />
        </v-col>
        <v-col cols="10" class="d-flex flex-column justify-center">
          <div class="text-body-1 black--text"> {{ product.name }}</div>
          <div>{{ product.category.name }}</div>
          <div class="text-caption">{{ product.ozellikler.map((o) => o.value).join(", ") }}</div>
        </v-col>
        <v-col class="py-0">Özellikler</v-col>
        <v-col cols="12" :key="variationKey" v-for="(variation, variationKey) in product.variations" class="py-0">
          <v-row>
            <v-col cols="6">
              <div>
                <div class="text-body-2 black--text mb-1">{{ getProductFeatures(product.attributes, variation.attrs).map((o) => o.name).join(', ') }}</div>
                <div>Miktar: {{ product.quantity }}</div>
              </div>
            </v-col>
            <v-col cols="6" class="d-flex flex-column justify-center">
              <div class="text-body-2 black--text mb-1">{{ $formatFiyat(variation.priceDecimal) }} </div>
              <div class="d-flex">
                <div :key="image" v-for="(image) in variation.images">
                  <v-tooltip top right color="white" content-class="img-thumb-preview">
                    <template v-slot:activator="{ on, attrs }">
                      <v-img width="20" :src="image"  class="rounded-sm" v-on="on" v-bind="attrs" />
                    </template>
                    <span>
                      <v-img width="250" :src="image"  class="rounded-sm" v-on="on" v-bind="attrs" />
                    </span>
                  </v-tooltip>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<style scoped>
.img-thumb-preview {
  opacity: 1 !important;
  padding: 0;
}
</style>